module.exports = __webpack_public_path__ + "img/Academedia.ed6955ff.png";